import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MenuItem, MessageService, PrimeIcons} from 'primeng/api';
import {saveAs} from 'file-saver';
import {Platform} from '@angular/cdk/platform';
import {InvoiceAndSoaService} from '../@shared/new-services/invoice-and-soa.service';
import {BookingService} from '../@shared/new-services/booking.service';

@Component({
    selector: 'app-documents-listing',
    templateUrl: './documents-listing.component.html',
    styleUrls: ['./documents-listing.component.scss']
})
export class DocumentsListingComponent implements OnInit {

    isInvoiceDocument = false;
    isStatementDocument = false;
    isBookingDocument = false;
    invoiceAndDocuments: any;
    statementAndDocuments: any;
    bookingDocuments: any;
    breadCrumbsModel: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    isLoading = false;

    constructor(private activatedRoute: ActivatedRoute,
                private messageService: MessageService,
                private router: Router,
                public platform: Platform,
                private invoiceAndSoaService: InvoiceAndSoaService,
                private bookingService: BookingService) {
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params: any) => {
            if (params) {
                console.log(params);
                if (params?.documentType === 'Invoice') {
                    this.isInvoiceDocument = true;
                    this.getInvoiceDocumentsByGid(params?.documentTypeGid);
                    this.breadCrumbsModel = [
                        {label: 'Invoices', icon: '', routerLink: '/invoices'},
                        {label: 'Invoice : ' + params?.documentNumber}
                    ];
                } else if (params?.documentType === 'SOA') {
                    this.isStatementDocument = true;
                    this.getStatementDocumentsByGid(params?.documentTypeGid);
                    this.breadCrumbsModel = [
                        {label: 'Statement of Accounts', icon: '', routerLink: '/account-statements'},
                        {label: 'Statement : ' + params?.documentNumber}
                    ];
                } else if (params?.documentType === 'Booking') {
                    this.isBookingDocument = true;
                    this.getBookingDocumentsByGid(params?.documentTypeGid);
                    this.breadCrumbsModel = [
                        {label: 'Bookings', icon: '', routerLink: '/booking-summary'},
                        {label: 'Booking : ' + params?.bookingId}
                    ];
                }
            }
        });
    }

    getInvoiceDocumentsByGid(documentTypeGid: any) {
        this.isLoading = true;
        this.invoiceAndSoaService
            .getInvoiceDocuments(documentTypeGid)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.invoiceAndDocuments = x;
                    x?.documents?.map((document) => {
                        if (document?.documentMimeType !== 'application/pdf') {
                            document.icon = PrimeIcons.FILE;
                        } else {
                            document.icon = null;
                        }
                    });
                }, (error) => {
                    this.isLoading = false;
                    this.invoiceAndDocuments = null;
                    this.messageService
                        .add(
                            {
                                key: 'document-listing-messages',
                                severity: 'error',
                                summary: 'Getting Documents List !',
                                detail: error?.message ? error?.message : error
                            }
                        );
                }
            );
    }

    getBookingDocumentsByGid(documentTypeGid: any) {
        this.isLoading = true;
        this.bookingService
            .getBookingDocumentsByGid(documentTypeGid)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.bookingDocuments = x;
                    x?.documents?.map((document) => {
                        if (document?.documentMimeType !== 'application/pdf') {
                            document.icon = PrimeIcons.FILE;
                        } else {
                            document.icon = null;
                        }
                    });
                }, (error) => {
                    this.isLoading = false;
                    this.bookingDocuments = null;
                    this.messageService
                        .add(
                            {
                                key: 'document-listing-messages',
                                severity: 'error',
                                summary: 'Getting Documents List !',
                                detail: error?.message ? error?.message : error
                            }
                        );
                }
            );
    }

    getStatementDocumentsByGid(documentTypeGid) {
        this.isLoading = true;
        this.invoiceAndSoaService
            .getStatementDocuments(documentTypeGid)
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.statementAndDocuments = x;
                    x?.documents?.map((document) => {
                        if (document?.documentMimeType !== 'application/pdf') {
                            document.icon = PrimeIcons.FILE;
                        } else {
                            document.icon = null;
                        }
                    });
                }, (error) => {
                    this.isLoading = false;
                    this.statementAndDocuments = null;
                    this.messageService
                        .add(
                            {
                                key: 'document-listing-messages',
                                severity: 'error',
                                summary: 'Getting Documents List !',
                                detail: error?.message ? error?.message : error
                            }
                        );
                }
            );
    }

    viewDocument(document: any) {
        if (document.documentMimeType !== 'application/pdf') {
            this.presentToastMessage('info', 'Cannot View this document, Please download to view !');
            return;
        }
        console.log(document?.reportGid + ' : Actual Value------');
        console.log(!document?.reportGid);
        this.router.navigate(['/', 'pdf-viewer'], {
            queryParams: {
                documentType: this.isInvoiceDocument ? 'Invoice' : (this.isBookingDocument ? 'Booking' : 'SOA'),
                documentNumber: document.documentXid,
                documentGid: document?.documentGid,
                allowToExport: document?.isDownloadAllowed
            }
        });
    }

    downloadPdf(document: any) {
        document.isDownloading = true;
        this.invoiceAndSoaService.getDocumentByDocumentGid(document?.documentGid).subscribe((x) => {
            document.isDownloading = false;
            const pdf = URL.createObjectURL(x);
            saveAs(pdf, this.isInvoiceDocument
                ? 'Invoice  - ' + document.documentXid
                : (this.isBookingDocument ? 'Booking - ' + document.documentXid : 'SOA - ' + document.documentXid));
        }, error => {
            document.isDownloading = false;
            console.log(error?.message ? error?.message : error);
            this.messageService.add({
                severity: 'error',
                detail: error?.message ? error?.message : error,
                summary: 'Download Error !',
                key: 'invoices-error'
            });
        });
    }

    presentToastMessage(severity: string, detail: string) {
        this.messageService
            .add({
                severity,
                detail,
                summary: 'Document Listing Message !',
                key: 'document-listing-message',
                life: 1500
            });
    }

    getColourStatus(shipmentInvoiceType: any) {
        switch (shipmentInvoiceType) {
            case 'AIR':
                return 'shipment-type-air';
            case 'LCL':
                return 'shipment-type-lcl';
            case 'FCL':
                return 'p-text-success';
            case 'Transport':
                return 'p-text-warning';
            case 'Service Job':
                return 'shipment-type-sj';
            case 'Clearance':
                return 'shipment-type-cc';
        }
    }


    getColoredBookingStatus(status: any) {
        switch (status) {
            case 'Arrived':
                return 'tertiary-bgcolor';
            case 'In Progress':
                return 'in-progress';
            case 'Delivered':
                return 'delivered';
            case 'Planned':
                return 'planned';
            case 'Confirmed':
                return 'confirmed';
            case 'Booking Created':
                return 'booking-created';
            case 'Completed':
                return 'planned';
            case 'Customs Cleared':
                return 'in-progress';
            case 'Stuffed':
                return 'tertiary-bgcolor';
            case 'Carted':
                return 'tertiary-bgcolor';
            case 'Departed':
                return 'delivered';
            case 'Sailed':
                return 'planned';
            case 'Document Received':
                return 'confirmed';
            case 'Truck Placed':
                return 'tertiary-bgcolor';
            case 'Truck Dispatched':
                return 'in-progress';
            case 'Initiated':
                return 'planned';
            case 'Cancelled':
                return 'blue-bgcolor';
        }
    }
}
